import { FlexBetween } from '@/shared/components/ui/FlexBetween';
import { Box, Button, Grid, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

interface StatBoxProps {
  title: string;
  value: string;
  increase: string;
  icon: ReactElement;
  description: string;
  theme: any; // Reemplaza 'any' con el tipo correcto para 'theme'
  backgroundColor: string;
  urlNavigate:string;
}

const StatBox: React.FC<StatBoxProps> = ({
  title,
  value,
  increase,
  icon,
  description,
  theme,
  backgroundColor,
  urlNavigate
}) => {

  const navigate = useNavigate();

  return (
    <div style={{
      margin: '5px', borderRadius: '10px',
      padding: "1.25rem 1rem",
      border: '1px solid #ededed'
    }}>
      <Grid container>
        <Grid item xs={12} container
          justifyContent={'space-between'}
          alignContent={'center'}
          alignItems={'center'}
        >
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ color: "#000" }}>
              {title}
            </Typography>
          </Grid>
          <Grid item >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 50,
                height: 50,
                borderRadius: '50%',
                backgroundColor: backgroundColor,
                color: 'white',
              }}
            >
              {icon}

            </div>


          </Grid>

        </Grid>

        <Grid item container xs={12}>
          <Typography
            variant="h3"
            fontWeight="600"
            sx={{ color: "#000" }}
          >
            {value}
          </Typography>
        </Grid>

        <Grid item container xs={12} justifyContent={'space-between'}>
          <Grid item >
            <Typography
              variant="h5"
              fontStyle="italic"
              sx={{ color: "#BA68C8" }}
            >
              {increase}
            </Typography>
          </Grid>
          <Grid item >
            <Button
            onClick={()=>{
              navigate(urlNavigate)
            }}
              variant='text'
              color='inherit'
            >
              <Typography variant='subtitle2' style={{ fontWeight: 'bold' }}>Ver todo</Typography>
            </Button>

          </Grid>
        </Grid>

      </Grid>

    </div>
  )
  return (
    <Box
      component="div" // Add the missing component property
      //gridColumn="span 3"
      gridRow="span 1"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      p="1.25rem 1rem"
      //flex="1 1 100%"
      borderRadius="0.55rem"
      width="100%"
      border={'1px solid #ccc'}
    >
      <FlexBetween>
        <Typography variant="h6" sx={{ color: theme.palette.secondary[100] }}>
          {title}
        </Typography>
        {icon}
      </FlexBetween>

      <Typography
        variant="h3"
        fontWeight="600"
        sx={{ color: theme.palette.secondary[200] }}
      >
        {value}
      </Typography>

      <FlexBetween gap="1rem">
        <Typography
          variant="h5"
          fontStyle="italic"
          sx={{ color: theme.palette.secondary.light }}
        >
          {increase}
        </Typography>

        <Typography>{description}</Typography>
      </FlexBetween>
    </Box>
  );
};

export default StatBox;
